import { Link } from 'react-router-dom'
import { ChevronLeftIcon } from '@heroicons/react/24/outline'

type Props = {
    /** Where the parent page lives, e.g. `/account/12/settings`. */
    to: string
    /** What the parent page is called, e.g. a profile name or "Profile settings". */
    label: string
}

/**
 * The parent link that sits above a page title in the masthead.
 *
 * Deliberately not a "back" control: these pages are reachable from several
 * places (the home profile list, the profile dashboard, a deep link), so
 * anything phrased as history lies about where it lands. This names the parent
 * in the URL hierarchy instead, which is true however you arrived.
 */
export default function MastheadBreadcrumb({ to, label }: Props) {
    return (
        <Link
            to={to}
            className="group -ml-1 inline-flex items-center gap-0.5 text-[13px] font-medium text-ink-500 hover:text-arwen-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-arwen-500 rounded"
        >
            <ChevronLeftIcon
                className="h-3.5 w-3.5 transition-transform group-hover:-translate-x-0.5"
                aria-hidden="true"
            />
            {label}
        </Link>
    )
}
